<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer';
const { isMrbilit } = useWhiteLabel();
</script>

<template>
    <div>
        <SiteHeader show-back sticky overlay-header-in-desktop />
        <slot />
        <SiteFooter />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
